import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'

// export const add_product = createAsyncThunk(
//   'product/add_product',
//   async (product, { rejectWithValue, fulfillWithValue }) => {
//     try {
//       const { data } = await api.post('/product-add', product, {
//         withCredentials: true,
//       })

//       return fulfillWithValue(data)
//     } catch (error) {
//       // console.log(error.response.data)
//       return rejectWithValue(error.response.data)
//     }
//   }
// )
export const add_product = createAsyncThunk(
  'product/add_product',
  async (productData, { rejectWithValue, fulfillWithValue }) => {
    try {
      // productData must be FormData if it contains files
      const { data } = await api.post('/product-add', productData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data', // important!
        },
      });

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// End Method

export const get_products = createAsyncThunk(
  'product/get_products',
  async (
    { parPage, page, searchValue, subCategoryId },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const queryParams = new URLSearchParams({
        page,
        searchValue,
        parPage,
        ...(subCategoryId && { subCategoryId }),
      }).toString()
      const { data } = await api.get(`/products-get?${queryParams}`, {
        withCredentials: true,
      })

      // const { data } = await api.get(
      //   `/products-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
      //   { withCredentials: true }
      // )
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const products_discount_get = createAsyncThunk(
  'product/products_discount_get',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/discount-products-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      )
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_product = createAsyncThunk(
  'product/get_product',
  async (productId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/product-get/${productId}`, {
        withCredentials: true,
      })

      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const update_product = createAsyncThunk(
  'product/update_product',
  async ({ productId, formData }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put(`/product-update/${productId}`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const product_image_update = createAsyncThunk(
  'product/product_image_update',
  async ({ formData, productId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        `/product-image-update/${productId}`,
        formData,
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method
export const delete_product = createAsyncThunk(
  'product/delete_product',
  async ({ productId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(`/delete-product/${productId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      console.error('Delete product error:', error.response.data) // Log the error response
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const delete_product_image = createAsyncThunk(
  'product/delete_product_image',
  async ({ productId, imageName }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(
        `/delete-product-image/${productId}/${encodeURIComponent(imageName)}`,
        {
          withCredentials: true,
        }
      )
      return fulfillWithValue(data) // Return the success data
    } catch (error) {
      console.error(
        'Delete product image error:',
        error.response?.data || error
      ) // Log error response
      return rejectWithValue(error.response?.data || error) // Return the error data
    }
  }
)
// End Method

export const productReducer = createSlice({
  name: 'product',
  initialState: {
    successMessage: '',
    errorMessage: '',
    successImageMessage: '',
    errorImageMessage: '',
    loader: false,
    products: [],
    product: '',
    totalProduct: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
    messageImageClear: (state, _) => {
      state.successImageMessage = ''
      state.errorImageMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(add_product.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(add_product.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(add_product.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
      })

      .addCase(get_products.fulfilled, (state, { payload }) => {
        state.totalProduct = payload.totalProduct
        state.products = payload.products
      })
      .addCase(products_discount_get.fulfilled, (state, { payload }) => {
        state.totalProduct = payload.totalProduct
        state.products = payload.products
      })

      .addCase(get_product.fulfilled, (state, { payload }) => {
        state.product = payload.product
      })

      .addCase(update_product.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(update_product.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(update_product.fulfilled, (state, { payload }) => {
        state.loader = false
        state.product = payload.product
        state.successMessage = payload.message
      })

      .addCase(product_image_update.fulfilled, (state, { payload }) => {
        state.product = payload.product
        state.successImageMessage = payload.message
      })
      .addCase(product_image_update.rejected, (state, { payload }) => {
        state.loader = false
        state.errorImageMessage = payload.error
      })

      .addCase(delete_product.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(delete_product.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.products = payload.products
      })
      .addCase(delete_product_image.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successImageMessage = payload.message
        state.product = payload.product
      })
  },
})
export const { messageClear, messageImageClear } = productReducer.actions
export default productReducer.reducer
